import UrlFields from './containers/UrlFields';
import Checkboxes from './containers/Checkboxes';
import ReactDOM from 'react-dom';
import {CONFIG} from './globals/config';
import setInitialState from './globals/state';
import {enableES5} from 'immer';

enableES5();

require( './globals/pcss/default.pcss' );

setInitialState();

ReactDOM.render(
	<div className={'go-live-checkbox-form'}>
		<Checkboxes />
		<UrlFields key={Math.random()} />
	</div>,
	document.querySelector( `[data-js="${CONFIG.selectors.wrap}"]` ) );
